import { render, staticRenderFns } from "./headers.vue?vue&type=template&id=fc917b5a&"
import script from "./headers.vue?vue&type=script&lang=ts&"
export * from "./headers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports